package gr.tech.pdfgenerator.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.pdfgenerator.infrastructure.data.GeneratorData
import gr.tech.pdfgenerator.styles.Theme
import gr.tech.pdfgenerator.styles.noBorder
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Text

val tabBoxStyle = CssStyle {
    base {
        Modifier
            .height(54.px)
            .padding(
                leftRight = 16.px,
                topBottom = 4.px
            )
            .noBorder()
            .borderRadius(4.px)
            .backgroundColor(Theme.DarkGreen.rgb)
            .color(Colors.White)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.15.cssRem)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .backgroundColor(Theme.MediumGreen.rgb)
    }
}

val tabSelectedNameStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Theme.MediumGreen.rgb)
    }
}

@Composable
fun TabView(
    tabNamesList: List<String>,
    tabComposableList: List<@Composable () -> Unit>,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Row(
            modifier = Modifier
                .borderBottom(1.px, LineStyle.Solid, Colors.Grey)
                .padding(bottom = 4.px)
                .margin(bottom = 8.px)
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Row(
                modifier = Modifier
                    .gap(6.px),
                horizontalArrangement = Arrangement.Start
            ) {
                tabNamesList.forEachIndexed { index, name ->
                    Button(
                        attrs = tabBoxStyle.toModifier()
                            .then(
                                if (GeneratorData.selectedTabIndex.value == index)
                                    tabSelectedNameStyle.toModifier()
                                else
                                    Modifier
                            )
                            .onClick {
                                GeneratorData.selectedTabName.value = name
                                GeneratorData.selectedTabIndex.value = index
                            }
                            .toAttrs()
                    ) {
                        Text(name)
                    }
                }
            }
        }
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            if (GeneratorData.selectedTabIndex.value >= 0) {
                tabComposableList[GeneratorData.selectedTabIndex.value]()
            }
        }
    }
}